import { BillingPreviewSport } from '../../types/adminInvoice';

export function formatSportPrice(sport: BillingPreviewSport): string {
  const currency = (sport.currency || 'usd').toUpperCase();

  if (sport.cost != null && Number.isFinite(sport.cost)) {
    if (currency === 'USD') {
      return `$${sport.cost.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
    }
    return `${sport.cost.toLocaleString(undefined, { minimumFractionDigits: 2 })} ${currency}`;
  }

  const cents = sport.price_cents ?? sport.price;
  if (cents == null) return '—';
  const amount = cents / 100;
  if (currency === 'USD') {
    return `$${amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  }
  return `${amount.toLocaleString(undefined, { minimumFractionDigits: 2 })} ${currency}`;
}

/** Format user_until / until unix (or 0 / missing → —). */
export function formatUserUntil(until?: number | string | null): string {
  if (until == null || until === '' || until === 0) return '—';
  let date: Date;
  if (typeof until === 'string') {
    date = new Date(until);
  } else {
    date = new Date(until > 1e12 ? until : until * 1000);
  }
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatUntilDate(until?: number | string | null): string {
  return formatUserUntil(until);
}

export function getBlockedReasonMessage(reason?: string | null): string {
  if (reason === 'already_subscribed') return 'Already subscribed or in grace';
  if (reason === 'active_grace') return 'Active grace period';
  if (reason === 'grace_ended') return 'Grace ended';
  if (reason === 'no_pricing') return 'No pricing configured';
  if (reason) return reason.replace(/_/g, ' ');
  return 'Not available for invoicing';
}
